<template>
  <div class="cropper-template" v-if="modalShow" ref="cropperWrapper">
    <!-- 模板实时窗口 -->
    <vue-draggable-resizable
      v-show="tempWindow.show"
      class="template-window"
      :w="tempWindow.width"
      :h="tempWindow.height"
      :x="tempWindow.x"
      :y="tempWindow.y"
      @dragging="dragPreview"
      @resizing="dragResize"
      :parent="true"
    >
      <div class="title">
        <p>看不清？试试拖拽窗口</p>
        <div class="oper-group">
          <span
            v-if="tempWindow.isFull"
            type="ios-browsers-outline"
            class="el-icon-minus mini-screen"
            @click="miniTempWindow"
            title="还原"
          />
          <span
            v-else
            class="el-icon-full-screen full-screen"
            @click="fullTempWindow"
            title="全屏"
          />
          <span class="el-icon-close close-btn" @click="closeTempWindow" />
        </div>
      </div>
      <div class="temp-image">
        <img :src="tempWindow.src" alt="示例图片" />
      </div>
    </vue-draggable-resizable>
    <div class="cropper-content-wrapper">
      <!-- 模板 -->
      <div class="col-wrapper template-wrapper">
        <div class="col-wrapper__header">
          <div class="text">
            <h2 class="main-title">1.模板查看</h2>
            <p class="sub-title">
              上传前请查看相关模板，可拖拽到模板窗口到任意位置
            </p>
          </div>
        </div>
        <div class="col-wrapper__body">
          <!-- 模板列表 -->
          <ul class="templates">
            <li
              class="template"
              v-for="(item, index) in templates"
              :key="index"
              @click="selectTempWindow(item.src)"
            >
              <div class="image">
                <img :src="item.src" alt="" />
              </div>
              <p class="name">{{ item.name }}</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 操作区 -->
      <div class="col-wrapper oper-wrapper">
        <div class="col-wrapper__header">
          <div class="text">
            <h2 class="main-title">2.上传并裁减</h2>
            <p class="sub-title warn">
              裁剪的区域应包含主要信息，不应包含标题、LOGO等。可参考具体左侧的模板操作。
            </p>
          </div>
          <div class="oper">
            <el-button
              v-if="image"
              type="primary"
              class="btn choose-btn"
              :loading="submitLoading"
              @click="$refs.file.click()"
            >
              <input
                type="file"
                ref="file"
                @change="loadImage($event)"
                accept="image/*"
              /><span class="el-icon-plus"></span>选择图片
            </el-button>
          </div>
        </div>
        <div class="col-wrapper__body">
          <!-- 裁剪区 -->
          <div class="cropper-wrap" :class="{ 'no-data': !image }" v-if="image">
            <cropper
              ref="cropper"
              classname="cropper"
              :src="image"
              @change="change"
            ></cropper>
            <!-- 工具栏 -->
            <div class="toolbar" v-show="image">
              <!-- 全屏 -->
              <el-button
                type="primary"
                size="small"
                class="tool-btn"
                icon="el-icon-full-screen"
                @click="cropResize('full')"
              ></el-button>
              <!-- 小屏 -->
              <el-button
                type="primary"
                size="small"
                class="tool-btn"
                icon="el-icon-minus"
                @click="cropResize('shrink')"
              ></el-button>
              <!-- 垂直全屏 -->
              <el-button
                type="primary"
                size="small"
                class="tool-btn"
                @click="cropResize('vertical')"
              >
                <img :src="assets.verticalIcon" alt="" />
              </el-button>
              <!-- 水平全屏 -->
              <el-button
                type="primary"
                size="small"
                class="tool-btn"
                @click="cropResize('horizontal')"
              >
                <img :src="assets.horizontalIcon" alt="" />
              </el-button>
            </div>
          </div>
          <!-- 暂无数据 -->
          <div class="no-data" v-else>
            <div class="guidance">
              <img :src="assets.guidance" alt="" />
              <p class="description">快速了解如何制作一张可用的图</p>
              <!-- 操作按钮组 -->
              <div class="oper-btn-group" style="justify-content: center">
                <!--<Button class="btn remove-btn" icon="md-remove" type="text" @click="$refs.file.click()">移除图片</Button>-->
                <el-button
                  type="primary"
                  class="btn choose-btn"
                  @click="$refs.file.click()"
                  :loading="submitLoading"
                >
                  <input
                    type="file"
                    ref="file"
                    @change="loadImage($event)"
                  /><span class="el-icon-plus"></span>选择图片
                  <!--accept="image/*"-->
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 预览/提交 -->
      <div class="col-wrapper submit-wrapper">
        <div class="col-wrapper__header">
          <div class="text">
            <h2 class="main-title">3.预览 / 上传</h2>
          </div>
        </div>
        <!-- 示例 -->
        <div class="preview-wrapper">
          <img :src="previewImage" alt="" v-if="previewImage" />
          <div class="previewCoordinates">
            <p>宽：{{ previewCoordinates.width }}像素</p>
            <p>高：{{ previewCoordinates.height }}像素</p>
            <p>上边距：{{ previewCoordinates.top }}像素</p>
            <p>左边距：{{ previewCoordinates.left }}像素</p>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="oper-btn-grop">
          <el-button
            type="primary"
            class="button submit-button"
            :disabled="!previewImage"
            :loading="submitLoading"
            @click="save"
            >上传</el-button
          >
          <!--<Button class="button cancel-button" type="text">取消</Button>-->
        </div>
        <!-- 错误信息 -->
        <p class="error" v-if="errorMsg">{{ errorMsg }}</p>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <span class="el-icon-error close-modal-btn" @click="closeModal"></span>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import DraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { validateFileType } from "@/libs/formValidate";
import { OSSUpload } from "@/libs/OSS/index.js";

export default {
  components: {
    Cropper,
    "vue-draggable-resizable": DraggableResizable
  },
  data() {
    return {
      // 资源
      assets: {
        verticalIcon: require("./assets/vertical.svg"),
        horizontalIcon: require("./assets/horizontal.svg"),
        guidance: require("@/assets/img/order-template/guidance.gif")
      },
      // 基本配置
      initCfg: {
        submitApi: "/bpsApi/ocrBill/billRecogize"
      },
      // 是否显示modal
      modalShow: false,
      // 模板列表
      templates: [
        {
          name: "《电子商业承兑汇票》模板1",
          src: require("@/assets/img/order-template/template1.png")
        },
        {
          name: "《电子商业承兑汇票》模板2",
          src: require("@/assets/img/order-template/template2.png")
        },
        {
          name: "《电子商业承兑汇票》模板3",
          src: require("@/assets/img/order-template/template3.png")
        },
        {
          name: "《电子商业承兑汇票》模板4",
          src: require("@/assets/img/order-template/template4.png")
        }
      ],
      // 原始文件
      initFile: null,
      // 原始上传的图片（bae64）
      image: null,
      // 图片文件
      imgFile: null,
      // 预览图片
      previewImage: "",
      previewCoordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      // 模板窗口
      tempWindow: {
        show: false,
        width: 400,
        height: 250,
        x: 0,
        y: 0,
        src: "",
        isFull: false
      },
      // 加载效果
      submitLoading: false,
      // 错误信息
      errorMsg: ""
    };
  },

  methods: {
    // 显示modal
    showModal() {
      this.modalShow = true;
    },

    // 选择图片
    async loadImage(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let imgTarget = input.files[0];

        // 判断是否是图片
        let type = imgTarget.type;
        let size = imgTarget.size;

        // 特殊处理
        // todo

        // 转换上传的图片为base64格式
        let reader = new FileReader();
        reader.onload = e => {
          this.image = e.target.result;
        };
        this.initFile = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },

    // 快捷修改框选区域
    cropResize(type) {
      this.$refs.cropper.setCoordinates(({ coordinates, imageSize }) => {
        const { width, height } = imageSize;

        if (type === "full") {
          // 全屏
          return { width, height, left: 0, top: 0 };
        } else if (type === "shrink") {
          // 小屏
          let newWidth = (width * 3) / 4;
          let newHeight = (height * 3) / 4;
          return {
            width: newWidth,
            height: newHeight,
            left: width / 2 - newWidth / 2,
            top: height / 2 - newHeight / 2
          };
        } else if (type === "vertical") {
          // 垂直全屏
          return { width };
        } else if (type === "horizontal") {
          // 水平全屏
          return { height };
        }
      });
    },

    change({ coordinates, canvas }) {
      this.previewCoordinates = coordinates;
      // 转base64
      this.previewImage = canvas.toDataURL();

      // 转file
      canvas.toBlob(blob => {
        this.imgFile = blob;
      }, this.initFile.type);
    },

    // 拖拽模板窗口
    dragPreview(x, y) {
      this.tempWindow.x = x;
      this.tempWindow.y = y;
    },

    // 改变模板窗口尺寸
    dragResize(x, y, width, height) {
      this.tempWindow.x = x;
      this.tempWindow.y = y;
      this.tempWindow.width = width;
      this.tempWindow.height = height;
    },

    // 关闭模板窗口
    closeTempWindow() {
      this.tempWindow.show = false;
    },

    // 打开窗口
    selectTempWindow(imgSrc) {
      this.tempWindow.show = true;
      this.tempWindow.src = imgSrc;
      this.adaptTempWindow(imgSrc);
    },

    // 全屏窗口
    fullTempWindow() {
      this.tempWindow.isFull = true;
      const { offsetWidth = 400, offsetHeight = 250 } = this.$refs[
        "cropperWrapper"
      ];
      this.dragResize(0, 0, offsetWidth, offsetHeight);
    },

    // 还原窗口大小
    miniTempWindow() {
      this.tempWindow.isFull = false;
      this.adaptTempWindow(this.tempWindow.src);
    },

    // 模板窗口宽高自适应
    adaptTempWindow() {
      const { offsetWidth, offsetHeight } = this.$refs["cropperWrapper"];
      this.tempWindow.width = Math.floor(offsetWidth * 0.5);
      this.tempWindow.height = Math.floor(offsetHeight * 0.4);
    },

    // 保存
    async save() {
      if (!this.imgFile) {
        this.$message.warning("请选择图片");
        return;
      }

      this.submitLoading = true;

      // ocr上传
      const ocrData = await OSSUpload("ocr", this.imgFile, {
        filename: this.initFile.name
      });

      if (!ocrData.uuid) {
        this.submitLoading = false;
        this.$message.error("上传失败，请重新上传");
        return;
      }

      // 图片识别
      const param = { uuid: ocrData.formatName };
      const formData = new FormData();
      formData.append("uuid", ocrData.uuid);
      this.$request
        .inquiry_ocrImg(param)
        .then(res => {
          if (res.code === 0) {
            this.closeModal();
            this.$emit("on-success", res["billMap"] || {});
          } else {
            this.errorMsg = res.msg;
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },

    // 关闭modal
    closeModal() {
      this.modalShow = false;
      this.clear();
    },

    // 清空
    clear() {
      this.image = "";
      this.previewImage = "";
      this.previewCoordinates.width = 0;
      this.previewCoordinates.height = 0;
      this.previewCoordinates.left = 0;
      this.previewCoordinates.top = 0;

      this.tempWindow.show = false;
      this.tempWindow.width = 400;
      this.tempWindow.height = 250;
      this.tempWindow.x = 0;
      this.tempWindow.y = 0;
      this.tempWindow.src = "";

      this.imgFile = null;

      this.errorMsg = "";
    }
  }
};
</script>

<style lang="scss">
@import "style";
</style>
